var constants = require('../constants');
var initialState = require('../../initialState');

var specialistReducer = function(state, action) {
    var newstate = Object.assign({}, state);

    switch (action.type) {
        case constants.SET_MY_SPECIALIST_REQUEST:
            newstate.isFetching = true;
            return newstate;
        case constants.SET_MY_SPECIALIST_SUCCESS:
            newstate.isFetching = false;
            newstate.mySpecialist = action.specialist;
            return newstate;
        case constants.SET_MY_SPECIALIST_FAILURE:
            newstate.isFetching = false;
            return newstate;
        case constants.SET_MY_SPECIALIST_PRACTICE:
            newstate.mySpecialistPractice = action.practice;
            return newstate;
        case constants.SET_SPECIALIST_PENDING_ACTION:
            newstate.specialistPendingAction = action.pendingAction;
            return newstate;
        case constants.REMOVE_SPECIALIST_PENDING_ACTION:
            newstate.specialistPendingAction = initialState.specialist.specialistPendingAction;
            return newstate;
        default: return state || initialState.specialist;
    }
}

module.exports = specialistReducer;



// WEBPACK FOOTER //
// ./src/common/modules/specialists/reducers/specialist.js